import React, { useState, useEffect } from "react";
import {
    MenuItem,
    SubMenu,
} from 'react-pro-sidebar';

export default function SubMenuItem({ label, icon, children, pageCode, pageIdx, activeMenu, menuItemClick, parentPath = null }) {

    const isProductPlanPage = pageCode && (
        pageCode.includes('ProductPlan') ||
        ['ProductPlanDaily', 'ProductPlanWeekly', 'ProductPlanMonthly', 'ProductPlanAnnually'].includes(pageCode)
    );

    const uniqueKey = (parentPath && !isProductPlanPage) ? `${parentPath}_${pageCode}` : pageCode;

    if (children && children.length > 0) {
        return (
          <SubMenu label={label} icon={icon}>
            {children.map((child, index) => (
              <SubMenuItem
                key={index}
                label={child.pageName}
                icon={child.icon}
                children={child.children}
                pageCode={child.pageCode}
                pageIdx={child.idx}
                activeMenu = {activeMenu}
                menuItemClick={menuItemClick}
                parentPath={label}
              />
            ))}
          </SubMenu>
        );
      } else {
        return <MenuItem
        active={activeMenu === uniqueKey}
        onClick={() => menuItemClick(pageCode, label, parentPath, pageIdx)}
        icon={icon}>
          {label}
          </MenuItem>;
      }

}
